import { Box } from "@intech/web-ui";
import styled from "styled-components";

export const Container = styled(Box)``;
